module.exports = {
    i18n: {
        localeDetection: false,
        defaultLocale: 'en-US',
        locales: [
            'en',
            'en-US',
        ],
    },
    async rewrites() {
        return [
            // {
            //     source: '/:path([^\\/]*-[ac]\\d+)*',
            //     destination: '/list/:path*',
            // },
            {
                source: '/:path([^\\/]*-p\\d+)*',
                destination: '/products/:path*',
            },
            {
                source: '/:path([^\\/]*-p\\d+-v\\d+)*',
                destination: '/products/:path*',
            },
        ]
    },
}